import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../estilo.css';

export default function Contato() {
  const { t } = useTranslation();

  return (
    <section id="contact" className="container-fluid contact-container">
      <div className="contact-inner">
        <header className="contact-heading">
          <span className="section-eyebrow">{t('contact.eyebrow')}</span>
          <h2 className="contact-title">{t('contact.title')}</h2>
          <p>{t('contact.intro')}</p>
        </header>

        <div className="contact-grid">
          <article className="contact-card">
            <h3>{t('contact.directTitle')}</h3>
            <p>{t('contact.directText')}</p>
            <div className="contact-links">
              <a
                href="https://wa.me/5542984241307"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                WhatsApp: (42) 98424-1307
              </a>
              <a href="mailto:contato@quantumtrades.com.br" className="contact-link">
                contato@quantumtrades.com.br
              </a>
            </div>
            <p className="contact-note">{t('contact.directNote')}</p>
          </article>

          <article className="contact-card">
            <h3>{t('contact.channelsTitle')}</h3>
            <p>{t('contact.channelsText')}</p>
            <div className="contact-links">
              <a
                href="https://www.youtube.com/@QuantumTradesBR"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                YouTube: @QuantumTradesBR
              </a>
              <a
                href="https://t.me/QuantumTradesBr"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                {t('contact.telegram')}
              </a>
            </div>
            <p className="contact-note">{t('contact.channelsNote')}</p>
          </article>

          <article className="contact-card contact-card--action">
            <h3>{t('contact.nextTitle')}</h3>
            <p>{t('contact.nextText')}</p>
            <div className="contact-actions">
              <Link to="/planos" className="btn btn-primary btn-lg">
                {t('contact.viewPlans')}
              </Link>
              <Link to="/cadastro" className="btn btn-default btn-lg">
                {t('contact.createAccount')}
              </Link>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
